module.exports = __webpack_public_path__ + "img/way_k.0a3ad594.png";